import type {
  AssessmentScorePillar,
  CategoryScores,
  Pillars,
} from "../../../types";
import { AssessmentScoreCategoryKey } from "./types";

export const assessmentScorePillars = [
  {
    key: "carbon",
    label: "Carbon",
    categories: [
      { key: "additionality", label: "Additionality" },
      { key: "baseline", label: "Baseline" },
      { key: "permanence", label: "Permanence" },
      { key: "leakageManagement", label: "Leakage Management" },
      { key: "accuracy", label: "Accuracy" },
      { key: "governance", label: "Governance" },
      { key: "transparency", label: "Transparency" },
    ],
  },
  {
    key: "biodiversity",
    label: "Biodiversity",
    categories: [
      { key: "baseline", label: "Baseline" },
      { key: "suitabilityAndRisks", label: "Suitability & Risks" },
      {
        key: "monitoringReportingAndVerification",
        label: "Monitoring, Reporting & Verification",
      },
      { key: "impact", label: "Impact" },
    ],
  },
  {
    key: "people",
    label: "People",
    categories: [
      { key: "baseline", label: "Baseline" },
      { key: "stakeholderInclusion", label: "Stakeholder Inclusion" },
      { key: "humanRights", label: "Human Rights" },
      { key: "equity", label: "Equity" },
      { key: "livelihoods", label: "Livelihoods" },
      { key: "education", label: "Education" },
      { key: "health", label: "Health" },
      { key: "transparency", label: "Transparency" },
    ],
  },
] as const;

export function getAssessmentCategoryScore<
  PillarKey extends AssessmentScorePillar,
>(
  pillars: Pillars | undefined,
  pillar: PillarKey,
  categoryKey: AssessmentScoreCategoryKey<PillarKey>,
): CategoryScores | undefined {
  const scores = pillars?.[pillar]?.scores;
  if (!scores) return undefined;

  const values = scores as Record<string, CategoryScores | number | undefined>;

  return values[categoryKey] as CategoryScores | undefined;
}
